import { Box, Card, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { FC } from 'react';
import { useMediaUp } from 'hooks';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    padding: theme.spacing(14, 0),
    margin: theme.spacing(10, 0),
    background: theme.palette.primary.dark,
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(15, 0),
    },
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(15, 0),
    },
  },
  title: {
    color: theme.palette.common.white,
    maxWidth: 515,
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
      marginBottom: 0,
    },
  },
  infoCard: {
    boxShadow: 'none',
    padding: theme.spacing(2, 6, 8),
    '&:hover': {
      background: theme.palette.primary[600],
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(5),
    },
  },
  gridItem: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.up('sm')]: {
      '&:not(:last-child)': {
        marginBottom: 0,
      },
    },
  },
  cardTitle: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(4),
    fontSize: 64,
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(10),
    },
  },
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const cardData: string[] = [
  'Uninterrupted delivery for enhanced post-launch operations.',
  'Steady unification to boost quality and speed up release time.',
  "Faster issue mending to respond to the customers' demands rapidly.",
  'Extensible infrastructure to control intricate systems at little to no risks.',
];

const DevOpsCards: FC = () => {
  const classes = useStyles();
  const isSmallUp = useMediaUp('sm');

  return (
    <Box className={classes.wrapper}>
      <Container maxWidth={false} fixed>
        <Grid container>
          <Grid className={classes.titleGrid} item lg={6} xs={12}>
            <Box>
              <Typography variant="h2" className={classes.title}>
                Integrate DevOps Development Solutions to Benefit from:
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={6} xs={12}>
            <Grid container spacing={isSmallUp ? 6 : 0}>
              {cardData.map((text, index) => (
                <InfoCard key={index + text} title={`0${index + 1}`} text={text} />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

interface InfoCardProps {
  title: string;
  text: string;
}

const InfoCard: FC<InfoCardProps> = ({ title, text }) => {
  const classes = useStyles();
  return (
    <Grid xs={12} sm={6} item className={classes.gridItem}>
      <Card className={classes.infoCard}>
        <Typography variant="h1" className={classes.cardTitle}>
          {title}
        </Typography>
        <Typography variant="body2">{text}</Typography>
      </Card>
    </Grid>
  );
};

export default DevOpsCards;
